// Query-string building for the list endpoints.
//
// The filter dialogs hold every field at once and hand back the untouched ones
// as '', so the URLs used to be assembled with `field !== '' ? ... : ''` tests
// per field. Those tests miss `undefined` (a field the caller simply did not
// pass), which put `&role=undefined` on the wire and emptied the table.
//
// buildQuery drops anything blank instead, and encodes what is left, so a
// filter the user did not fill in is absent rather than blank.
export function buildQuery(params) {
  const search = new URLSearchParams();
  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return;
    search.append(key, value);
  });
  const query = search.toString();
  return query ? `?${query}` : '';
}

export default buildQuery;
